var render, staticRenderFns
import script from "./anchored-tag.vue?vue&type=script&lang=js&"
export * from "./anchored-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f6108d')) {
      api.createRecord('53f6108d', component.options)
    } else {
      api.reload('53f6108d', component.options)
    }
    
  }
}
component.options.__file = "src/js/components/anchored-tag.vue"
export default component.exports